import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import '../../assets/css/carousel.css';
import { CMS_LOCATION } from '../../constants/constants';

class Rotator extends React.Component {

    constructor(props) {
        super(props);
        this.transform = 0;
        this.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;
        this.buttonKeyActionPagination = this.buttonKeyActionPagination.bind(this);
        this.UpdatedPaginationVal = this.UpdatedPaginationVal.bind(this);
        this.state = {
            activeTabIndex :0,
        }
    }
    navigateNextSlide(e) {
        document.querySelector('.carousel_item.active').classList.remove('active');
        if(e.target.classList.contains('prev_btn')) {
            document.querySelectorAll('.carousel_item')[0].classList.add('active');
            document.querySelector('.carousel_pager-item.next_btn').classList.remove('active');
            document.querySelector('.carousel_pager-item.prev_btn').classList.add('active');
            document.querySelector('.button.prev_btn').classList.remove('active');
            document.querySelector('.button.next_btn').classList.add('active');
            //window.scLinkTrackID(' Return your equipment in four easy steps| Return Kit Instructions');
        } else if(e.target.classList.contains('next_btn')) {
            document.querySelectorAll('.carousel_item')[1].classList.add('active');
            document.querySelector('.carousel_pager-item.prev_btn').classList.remove('active');
            document.querySelector('.carousel_pager-item.next_btn').classList.add('active');
            document.querySelector('.button.prev_btn').classList.add('active');
            document.querySelector('.button.next_btn').classList.remove('active');
            //window.scLinkTrackID(' Return your equipment in four easy steps| Next button');
        }
    }

    toggleNextSlide(e) {
        let target = e.target;
        let parentElement = e.target.offsetParent.querySelector('.owl-wrapper');
        let currentSlideIndex = parseInt(e.target.parentElement.offsetParent.querySelector('.owl-pagination .active').getAttribute('data-item'), 10);
        let nextSlideIndex = parseInt(e.target.parentElement.getAttribute('data-item'), 10);
        let sliderElementWidth = e.target.offsetParent.querySelector('.owl-wrapper .owl-item').getClientRects()[0].width;
        this.transform = (nextSlideIndex === parentElement.querySelectorAll('.owl-item').length || 0) ? 0 : sliderElementWidth * nextSlideIndex;
        parentElement.setAttribute('style', "transform: translate3d(-" + this.transform + "px, 0px, 0px)");
        let firstParentElement = e.target.parentElement.offsetParent;
        firstParentElement.querySelector('.owl-item.active').classList.remove('active');
        firstParentElement.querySelector('.' + target.getAttribute('class')).classList.add('active');
        firstParentElement.querySelector('.owl-pagination .active').classList.remove('active');
        // firstParentElement.setAttribute('aria-live', 'off');;
        // target.parentElement.setAttribute('aria-live', 'polite');;
        target.parentElement.classList.add('active');

        this.setState({activeTabIndex : parseInt( target.parentElement.getAttribute('data-item'))});
        }

    openSlideinButtonClick(e) {
        console.log("buttonKey Event343");
        console.log("NVDA-tool-logging");
        //look 
        let target = e.target;
        let nextSlideIndex;

        let parentElement = e.target.parentElement.offsetParent;
        let indexvalue;

        // let currentActiveSlide = parentElement.querySelector('.owl-item.active');
        // let lichilds = currentActiveSlide.querySelector('li')
        // var divchilds = lichilds.querySelectorAll('.owl-item.active .battery-compartment .cbu-steps-title')

        // var innerTexts = [];
        // for (var i = 0; i < divchilds.length; i++) {
        //     var innerText = divchilds[i].innerText;
        //     innerTexts.push(innerText)
        // }

        // var cominedText = innerTexts.join('')
        // console.log("titleDivs",cominedText)

        let currentActiveIndex = parseInt(parentElement.querySelector('.owl-item.active').getAttribute('data-item'), 10);
        if (e.target.innerText === "Next") {
            nextSlideIndex = (parentElement.querySelectorAll('.owl-item').length === currentActiveIndex + 1) ? 0 : (currentActiveIndex + 1);
        } else {
            nextSlideIndex = (currentActiveIndex === 0) ? parentElement.querySelectorAll('.owl-item').length-1 : (currentActiveIndex - 1);
        }
        let sliderElementWidth = parentElement.querySelector('.owl-wrapper .owl-item').getClientRects()[0].width;
        this.transform = (nextSlideIndex === parentElement.querySelectorAll('.owl-item').length || 0) ? 0 : sliderElementWidth * nextSlideIndex;
        parentElement.querySelectorAll('.owl-item')[nextSlideIndex].parentElement.setAttribute('style', "transform: translate3d(-" + this.transform + "px, 0px, 0px)");
        if(target.classList.contains('owl-prev')) {
            let totalItems = parentElement.getElementsByClassName('owl-item').length;
            parentElement.querySelector('.owl-item.active').classList.remove('active');
            if(parentElement.getElementsByClassName('owl-item')[currentActiveIndex-1] === undefined || parentElement.getElementsByClassName('owl-item')[currentActiveIndex-1] === null) {
                parentElement.getElementsByClassName('owl-item')[totalItems-1].classList.add('active');
                parentElement.querySelector('.owl-pagination .active').classList.remove('active');
                parentElement.querySelectorAll('.owl-page')[totalItems-1].classList.add('active');
                indexvalue = parseInt(document.querySelector('.owl-item.active').getAttribute('data-item'), 10);

            } else {
                parentElement.getElementsByClassName('owl-item')[currentActiveIndex-1].classList.add('active');
                parentElement.querySelector('.owl-pagination .active').classList.remove('active');
                parentElement.querySelectorAll('.owl-page')[currentActiveIndex-1].classList.add('active');
                indexvalue = parseInt(document.querySelector('.owl-item.active').getAttribute('data-item'), 10);

            }

            this.UpdatedPaginationVal(e,currentActiveIndex,"Prev");
        } else if(target.classList.contains('owl-next')) {
            parentElement.querySelector('.owl-item.active').classList.remove('active');
            if(parentElement.getElementsByClassName('owl-item')[currentActiveIndex+1] === undefined || document.getElementsByClassName('owl-item')[currentActiveIndex+1] === null) {
                parentElement.getElementsByClassName('owl-item')[0].classList.add('active');
                parentElement.querySelector('.owl-pagination .active').classList.remove('active');
                parentElement.querySelectorAll('.owl-page')[0].classList.add('active');
                indexvalue = parseInt(document.querySelector('.owl-item.active').getAttribute('data-item'), 10);

            } else {
                parentElement.getElementsByClassName('owl-item')[currentActiveIndex+1].classList.add('active');
                parentElement.querySelector('.owl-pagination .active').classList.remove('active');
                parentElement.querySelectorAll('.owl-page')[currentActiveIndex+1].classList.add('active'); 
                indexvalue=  parseInt(document.querySelector('.owl-item.active').getAttribute('data-item'), 10);

            }
            this.UpdatedPaginationVal(e,indexvalue,"Next");
        }
    }

    openSlideinButtonEnterKeyEvt(e) {
        console.log("buttonKey Event34");
        console.log("HHHH",e.keyCode);
        if (e.keyCode === 13) {
            console.log("buttonKey Event35");
        console.log("NVDA-toolEnterKey-logging")
        let target = e.target;
        let nextSlideIndex;
        let parentElement = e.target.parentElement.offsetParent;
        let indexvalue;
        let currentActiveIndex = parseInt(parentElement.querySelector('.owl-item.active').getAttribute('data-item'), 10);
        if (e.target.innerText === "Next") {
            nextSlideIndex = (parentElement.querySelectorAll('.owl-item').length === currentActiveIndex + 1) ? 0 : (currentActiveIndex + 1);
        } else {
            nextSlideIndex = (currentActiveIndex === 0) ? parentElement.querySelectorAll('.owl-item').length-1 : (currentActiveIndex - 1);
        }
        let sliderElementWidth = parentElement.querySelector('.owl-wrapper .owl-item').getClientRects()[0].width;
        this.transform = (nextSlideIndex === parentElement.querySelectorAll('.owl-item').length || 0) ? 0 : sliderElementWidth * nextSlideIndex;
        parentElement.querySelectorAll('.owl-item')[nextSlideIndex].parentElement.setAttribute('style', "transform: translate3d(-" + this.transform + "px, 0px, 0px)");
        if(target.classList.contains('owl-prev')) {
            console.log("prev index current :"+currentActiveIndex);
            let totalItems = parentElement.getElementsByClassName('owl-item').length;
            parentElement.querySelector('.owl-item.active').classList.remove('active');
            if(parentElement.getElementsByClassName('owl-item')[currentActiveIndex-1] === undefined || parentElement.getElementsByClassName('owl-item')[currentActiveIndex-1] === null) {
                parentElement.getElementsByClassName('owl-item')[totalItems-1].classList.add('active');
                parentElement.querySelector('.owl-pagination .active').classList.remove('active');
                parentElement.querySelectorAll('.owl-page')[totalItems-1].classList.add('active');
                indexvalue = parseInt(document.querySelector('.owl-item.active').getAttribute('data-item'), 10);
            } else {
                parentElement.getElementsByClassName('owl-item')[currentActiveIndex-1].classList.add('active');
                parentElement.querySelector('.owl-pagination .active').classList.remove('active');
                parentElement.querySelectorAll('.owl-page')[currentActiveIndex-1].classList.add('active');
                indexvalue = parseInt(document.querySelector('.owl-item.active').getAttribute('data-item'), 10);
            }
            this.UpdatedPaginationVal(e,currentActiveIndex,"Prev");
        } else if(target.classList.contains('owl-next')) {
            console.log("Next index current :"+currentActiveIndex);
            parentElement.querySelector('.owl-item.active').classList.remove('active');
            if(parentElement.getElementsByClassName('owl-item')[currentActiveIndex+1] === undefined || document.getElementsByClassName('owl-item')[currentActiveIndex+1] === null) {
                parentElement.getElementsByClassName('owl-item')[0].classList.add('active');
                parentElement.querySelector('.owl-pagination .active').classList.remove('active');
                parentElement.querySelectorAll('.owl-page')[0].classList.add('active');
                indexvalue = parseInt(document.querySelector('.owl-item.active').getAttribute('data-item'), 10);
                console.log("Next data 2 :"+indexvalue);
            } else {
                parentElement.getElementsByClassName('owl-item')[currentActiveIndex+1].classList.add('active');
                parentElement.querySelector('.owl-pagination .active').classList.remove('active');
                parentElement.querySelectorAll('.owl-page')[currentActiveIndex+1].classList.add('active'); 
                indexvalue=  parseInt(document.querySelector('.owl-item.active').getAttribute('data-item'), 10);
                console.log("Next data 1 :"+indexvalue);
            }
            this.UpdatedPaginationVal(e,indexvalue,"Next");
        }
       
     }
    }

    buttonKeyActionPagination(e) {
        console.log("KeyCode-buttonKey" +e.keyCode);
        
        if (e.keyCode === 13) {
            console.log("KeyCode-buttonKey - NVDA");
            let itemIndex = parseInt(e.target.getAttribute('data-item'));
            itemIndex = itemIndex + 1;
            let pagecountitem = e.target.parentElement.querySelectorAll('.owl-page');
            let indexcount = 0;
            for(var i=0;i<pagecountitem.length;i++){
                indexcount =0;
                indexcount = i+1
               pagecountitem[i].classList.remove('active');
               pagecountitem[i].lastChild.setAttribute('aria-label', 'Slide '+ indexcount +' button');
               pagecountitem[i].lastChild.setAttribute('aria-selected', false);
            }

            e.target.classList.add('active');
            let spanId = "span"+itemIndex;
            spanId = spanId.trim();
            document.getElementById(spanId).setAttribute('aria-label', '');
            document.getElementById(spanId).setAttribute('aria-label', 'Slide ' + itemIndex + ' button Selected');
            document.getElementById(spanId).setAttribute('aria-selected', true);
           
        }
        console.log("pagination tab  :"+ e.keyCode);
    }

    UpdatedPaginationVal(e,currentActiveIndex,Action){
        console.log("UpdatedPaginationVal index current :"+currentActiveIndex);
        let parentElement = e.target.parentElement.offsetParent;
        let pagecountitem = parentElement.getElementsByClassName('owl-item');
        let indexcount = 0;
       
            let itemIndex = currentActiveIndex;
            if(Action =="Next"){
                if(currentActiveIndex == 0){
                    itemIndex = 1; 
                }else{
                    itemIndex = itemIndex + 1;
                }           
            }
            else{
                if(currentActiveIndex == 0){
                    itemIndex =  pagecountitem.length;
                }else{
                    itemIndex = itemIndex ; 
                }
                
            }
           
            
        for (var i = 0; i < pagecountitem.length; i++) {
            indexcount = 0;
            indexcount = i + 1
            let spanIDv = "span" + indexcount;
            document.getElementById(spanIDv).setAttribute('aria-label', '');
            document.getElementById(spanIDv).setAttribute('aria-label', 'Slide ' + indexcount );
            document.getElementById(spanIDv).setAttribute('aria-selected', 'off');
            document.getElementById(spanIDv).setAttribute('aria-live', 'off');
        }
            let spanId = "span"+itemIndex;
            spanId = spanId.trim();
            let currentActiveSlide = parentElement.querySelector('.owl-item.active');
            let lichilds = currentActiveSlide.querySelector('li')
            var divchilds = lichilds.querySelectorAll('.owl-item.active .battery-compartment .cbu-steps-title')
    
            var innerTexts = [];
            for (var i = 0; i < divchilds.length; i++) {
                var innerText = divchilds[i].innerText;
                innerTexts.push(innerText)
            }
    
            var combinedTitles = innerTexts.join(' ')
            console.log("combinedTitles--->",combinedTitles)

            document.getElementById(spanId).setAttribute('aria-label', '');
            document.getElementById(spanId).setAttribute('aria-label', 'Slide ' + itemIndex + 'Selected');
            document.getElementById(spanId).setAttribute('aria-selected', 'true');
            document.getElementById(spanId).setAttribute('aria-live', 'polite');
    }

    render() {
        if(this.props.type === "equipmentreturn") {
            return (
                <div className="relative margin-bottom-small small-border-top">
                    <div className="w_carousel m_carousel_return" id="ReturnEquipments">
                        <ul className= {(this.isMobile) ? "responsive carousel_list" : "carousel_list" }  key="carousel_list">
                            {
                                this.props.Data.map((item, index) => {
                                    return   <React.Fragment key={"rotator"+index}>
                                                <li className={(index===0)? "carousel_item active" : "carousel_item"} key={"level1"+index}>
                                                    <div className="tiny-12 medium-6 column">
                                                        <div className="row medium-padding-vert-small">
                                                            <ul className="left no-bullet inline-block" key={"ull1" + index}>
                                                                <li className="padding-right-tiny" key={"level11" + index}>
                                                                    <span className="circled bold" title={item.lefttitle}>
                                                                        {item.leftcirclenumber}
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                            <ul className="large-left no-bullet large-p-80 medium-padding-left-small inline-block" key={"ull2" + index}>
                                                                <li className="title" key={"level12" + index}>
                                                                    <p className="text-large bold margin-bottom-zero">
                                                                        {item.lefttitle}
                                                                    </p>
                                                                    <p>
                                                                        {item.leftdescription}
                                                                    </p>
                                                                </li>
                                                            </ul>
                                                            <div className="clear text-center">
                                                                <img alt="courosel_image" src={CMS_LOCATION + item.leftimage}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tiny-12 medium-6 column">
                                                        <div className="row padding-vert-small">
                                                            <ul className="left no-bullet inline-block" key={"level2" + index}>
                                                                <li className="padding-right-tiny" key={"level21" + index}>
                                                                    <span className="circled bold" title={item.righttitle}>{item.rightcirclenumber}</span>
                                                                </li>
                                                            </ul>
                                                            <ul className="large-left no-bullet large-p-80 medium-padding-left-small margin-bottom-zero inline-block" key={"ul2" + index}>
                                                                <li key={"level22" + index}>
                                                                    <p className="text-large bold margin-bottom-zero">{item.righttitle}</p>
                                                                    <p className="text-small">
                                                                    {item.rightdescription}
                                                                    </p>
                                                                </li>
                                                            </ul>
                                                            <div className="clear text-center">
                                                                <img alt="courosl" className="mw-medium" src={CMS_LOCATION + item.rightimage}>
                                                                </img>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                    </React.Fragment>

                                })
                            }
                        </ul>
                        <div className="carousel_pager">
                            <a className="button no-icon auto narrow w-medium text-center medium-p-20 prev_btn" onClick={this.navigateNextSlide.bind(this)} data-track="Back"> Back</a>
                            <div className="carousel_pager-list">
                            <span className="carousel_pager-item active prev_btn"  onClick={this.navigateNextSlide.bind(this)}></span><span className="carousel_pager-item next_btn"  onClick={this.navigateNextSlide.bind(this)}></span></div>
                            <a className="button no-icon auto w-medium text-center medium-p-20 next_btn active" onClick={this.navigateNextSlide.bind(this)} data-track="Next">Next</a></div>
                        </div>
                </div>
            )
        } else if (this.props.type === "replacement") {
            return (
                <React.Fragment key="rotator">
                    <div className="carousel">
                        <div className="row">
                            <div className="w_carousel">
                                <div className="battery-replacement">
                                    <ul className="carousel_list tiny-flex-grid-1 medium-flex-grid-2 cbu-steps owl-carousel owl-theme" key="list" >
                                        <div className="owl-wrapper-outer autoHeight">
                                            <div className="owl-wrapper" key="replacment_carousel">
                                                {
                                                    this.props.Data.map((item, index) => {
                                                        return <div className={(index===0)? "owl-item active slide" + (index + 1): "owl-item slide"  + (index + 1)} key={"root"+index} data-item={index}>
                                                            <li className="carousel_item" key={"carousel"+index}>
							                                    <div className="battery-compartment">
							 	                                    <img src={CMS_LOCATION + item.leftimage} width="200" />
                                                                     <div class="cbu-steps-title">{item.lefttitle}</div>
								                                    <div className="cbu-steps-text">{item.leftdescription}</div>
							                                    </div>
                                                                <div className="battery-compartment">
							 	                                    <img src={CMS_LOCATION + item.rightimage} width="200"/>
                                                                     <div class="cbu-steps-title">{item.righttitle}</div>
								                                    <div className="cbu-steps-text">{item.rightdescription}</div>
							                                    </div>
						                                    </li>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="owl-controls clickable">
                                                <div className="owl-pagination" >
                                                    {
                                                        this.props.Data.map((item, index)=> {
                                                            return   <div className={(index===0)? "owl-page active": "owl-page" } data-item={index} tabIndex="0" onKeyDown={this.buttonKeyActionPagination.bind(this)}>
                                                                <span className={"slide"+(index+1)} id={"span"+(index+1)} onClick={this.toggleNextSlide.bind(this)} role='button' aria-label={ this.state.activeTabIndex == index ? "selected slide"+(index+1) : "slide"+(index+1)} aria-live={this.state.activeTabIndex == index ? "polite" :"off"} > </span>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                                <div className="owl-buttons">
                                                    <div className="owl-prev" aria-label='Previous' tabIndex="0" role="button" onClick={this.openSlideinButtonClick.bind(this)} onKeyDown={this.openSlideinButtonEnterKeyEvt.bind(this)}>Previous</div>
                                                    <div className="owl-next" aria-label='Next'  tabIndex="0" role="button"  onClick={this.openSlideinButtonClick.bind(this)} onKeyDown={this.openSlideinButtonEnterKeyEvt.bind(this)}>Next</div>
                                                </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        } else if (this.props.type === "battery") {
            return(
                <React.Fragment key="rotator">
                    <div className="carousel">
                        <div className="row">
                            <div className="w_carousel">
                                <div className="battery-backup">
                                    <ul className="carousel_list owl-carousel owl-theme" key="list">
                                        <div className="owl-wrapper-outer autoHeight courosel2">
                                            <div className="owl-wrapper" key="wrapper">
                                                {
                                                    this.props.Data.map((item, index) => {
                                                        return   <div className={(index===0)? "owl-item active slide" + (index + 1): "owl-item slide"  + (index + 1)} key={"root"+index} data-item={index}>
                                                            <li className="carousel_item" key={"carousel_list"+index}>
                                                                <div className="medium-6 battery-items">
                                                                    <div className="wrapper">
                                                                        <h3 className="h6 margin-top-zero margin-bottom-zero">{item.title}</h3>
                                                                        {ReactHtmlParser(item.richText)}
                                                                        {RenderImage(item)}
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="owl-controls clickable">
                                                <div className="owl-pagination" tabIndex="0">
                                                    {
                                                        this.props.Data.map((item, index)=> {
                                                            return   <div className={(index===0)? "owl-page active": "owl-page" } data-item={index} tabIndex="0" onKeyDown={this.buttonKeyActionPagination.bind(this)}>
                                                                <span className={"slide"+(index+1)} id={"span"+(index+1)} onClick={this.toggleNextSlide.bind(this)} aria-label={"slide"+(index+1)} role="button" ></span>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                                <div className="owl-buttons">
                                                    <div className="owl-prev" aria-label='Previous' tabIndex="0" role="button" onClick={this.openSlideinButtonClick.bind(this)} onKeyDown={this.openSlideinButtonEnterKeyEvt.bind(this)}>Previous</div>
                                                    <div className="owl-next" aria-label='Next'  tabIndex="0" role="button" onClick={this.openSlideinButtonClick.bind(this)} onKeyDown={this.openSlideinButtonEnterKeyEvt.bind(this)}>Next</div>
                                                </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
}

export default Rotator

function RenderImage(item) {
    if(item.image2 !== null) {
        return (
            <React.Fragment key="rotator_images">
                <img className="first_image" src={CMS_LOCATION + item.image1} alt={item.title}/>
                <img className="second_image" src={CMS_LOCATION + item.image2} alt={item.title}/>
            </React.Fragment>
        )
    } else {
        return (
            <img className="first_image" src={CMS_LOCATION + item.image1} alt={item.title}/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/Rotator.js